import script from "./IEventItem.vue?vue&type=script&setup=true&lang=js"
export * from "./IEventItem.vue?vue&type=script&setup=true&lang=js"

import "./IEventItem.vue?vue&type=style&index=0&id=169dfa5a&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-169dfa5a"]])

export default __exports__